<template>
  <div v-if="richiesto || presente" class="preventivo-firmato">
    <div class="preventivo-firmato__riga">
      <button
        v-if="richiesto"
        type="button"
        class="preventivo-firmato__tasto preventivo-firmato__tasto--carica"
        @click="scegli"
      >
        <i class="pi pi-upload"></i> Carica preventivo firmato
      </button>
      <input
        ref="inputFile"
        type="file"
        accept=".pdf,.jpg,.jpeg,.png"
        multiple
        class="preventivo-firmato__input"
        @change="onFile"
      />
      <button
        v-if="presente && !fileSalvati.length"
        type="button"
        class="preventivo-firmato__tasto preventivo-firmato__tasto--scarica"
        @click="scarica()"
      >
        <i class="pi pi-download"></i> Scarica Preventivo firmato
      </button>
    </div>
    <div class="preventivo-firmato__dettaglio">
      <ul v-if="fileSalvati.length" class="preventivo-firmato__lista">
        <li v-for="file in fileSalvati" :key="file.id">
          <span>{{ file.nome_file }}</span>
          <button type="button" class="preventivo-firmato__scarica" @click="scarica(file)">
            Scarica
          </button>
        </li>
      </ul>
      <ul v-if="richiesto && filesScelti.length" class="preventivo-firmato__lista">
        <li v-for="(file, indice) in filesScelti" :key="file.name + indice">
          <span class="preventivo-firmato__nome">{{ file.name }}</span>
          <button type="button" class="preventivo-firmato__togli" @click="togli(indice)">
            Rimuovi
          </button>
        </li>
      </ul>
      <span v-else-if="richiesto" class="preventivo-firmato__obb">File obbligatorio</span>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import Service from "@/services/ask-pratiche/gestione-pratiche";
import {
  caricaIdPreventiviFirmati,
  isPreventivoFirmato,
  onPreventivoFirmatoCaricato,
} from "@/services/ask-pratiche/preventivoFirmato";

export default {
  name: "PreventivoFirmatoBox",
  props: {
    stato: {
      type: [Object, String],
      default: null,
    },
    praticaId: {
      type: [Number, String],
      default: null,
    },
    typeFile: {
      type: String,
      required: true,
    },
  },
  emits: ["file"],
  setup(props, { emit }) {
    const service = new Service();
    const inputFile = ref(null);
    const filesScelti = ref([]);
    const fileSalvati = ref([]);
    const presente = ref(false);
    let smetti = () => {};

    const richiesto = computed(() => isPreventivoFirmato(props.stato));

    const aggiornaPresenza = async () => {
      if (!props.praticaId) {
        presente.value = false;
        fileSalvati.value = [];
        return;
      }
      try {
        const ids = await caricaIdPreventiviFirmati(service, props.typeFile);
        presente.value = ids.has(Number(props.praticaId));
      } catch (error) {
        presente.value = false;
      }
      try {
        fileSalvati.value = await service.elencoFilePreventivoFirmato(
          props.praticaId,
          props.typeFile
        );
        if (fileSalvati.value.length) {
          presente.value = true;
        }
      } catch (error) {
        fileSalvati.value = [];
      }
    };

    const scegli = () => {
      inputFile.value?.click();
    };

    const onFile = (event) => {
      const aggiunti = Array.from(event.target.files || []);
      if (aggiunti.length) {
        filesScelti.value = filesScelti.value.concat(aggiunti);
        emit("file", filesScelti.value.slice());
      }
      event.target.value = "";
    };

    const togli = (indice) => {
      filesScelti.value.splice(indice, 1);
      emit("file", filesScelti.value.length ? filesScelti.value.slice() : null);
    };

    const scarica = async (file) => {
      await service.downloadPreventivoFirmato(
        props.praticaId,
        props.typeFile,
        file?.id
      );
    };

    onMounted(() => {
      aggiornaPresenza();
      smetti = onPreventivoFirmatoCaricato((typeFile, id) => {
        if (typeFile === props.typeFile && Number(id) === Number(props.praticaId)) {
          presente.value = true;
          filesScelti.value = [];
          aggiornaPresenza();
        }
      });
    });

    onUnmounted(() => {
      smetti();
    });

    watch(
      () => [props.praticaId, props.typeFile],
      () => {
        filesScelti.value = [];
        aggiornaPresenza();
      }
    );

    watch(
      () => props.stato,
      (stato) => {
        if (!isPreventivoFirmato(stato)) {
          filesScelti.value = [];
          emit("file", null);
        }
      }
    );

    return {
      inputFile,
      filesScelti,
      fileSalvati,
      presente,
      richiesto,
      scegli,
      onFile,
      togli,
      scarica,
    };
  },
};
</script>

<style scoped>
.preventivo-firmato {
  width: 100%;
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  column-gap: 12px;
  row-gap: 6px;
  margin: 0;
  padding: 4px 0 0;
}

.preventivo-firmato::before {
  content: "Preventivo firmato";
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.preventivo-firmato__riga {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.preventivo-firmato__tasto {
  display: inline-block;
  font-size: 13px;
  line-height: 1.25;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin: 0 8px 0 0;
  text-align: center;
  width: auto;
  min-height: 32px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}

.preventivo-firmato__tasto:hover {
  background-color: #2980b9;
}

.preventivo-firmato__input {
  display: none;
}

.preventivo-firmato__dettaglio {
  grid-column: 2;
  min-width: 0;
}

.preventivo-firmato__lista {
  list-style: none;
  margin: 0;
  padding: 0;
}

.preventivo-firmato__lista li {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 4px;
  color: #334155;
  font-size: 13px;
}

.preventivo-firmato__lista li span {
  min-width: 0;
  word-break: break-all;
}

.preventivo-firmato__scarica,
.preventivo-firmato__togli {
  flex: none;
  border: none;
  background: transparent;
  color: #0f3d6e;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.preventivo-firmato__nome,
.preventivo-firmato__obb {
  display: block;
  font-size: 13px;
  margin: 0;
  text-align: left;
}

.preventivo-firmato__nome {
  color: #0f6b4c;
  word-break: break-all;
}

.preventivo-firmato__obb {
  color: #b42318;
  font-weight: 600;
}

@media (max-width: 900px) {
  .preventivo-firmato {
    grid-template-columns: 1fr;
  }

  .preventivo-firmato__dettaglio {
    grid-column: 1;
  }
}
</style>
